const EMOJI_MARKER_BAKERY_IMAGE = require('./emoji-marker-bakery.png')
const EMOJI_MARKER_BEER_IMAGE = require('./emoji-marker-beer.png')
const EMOJI_MARKER_BOOKS_IMAGE = require('./emoji-marker-books.png')
const EMOJI_MARKER_CAFE_IMAGE = require('./emoji-marker-cafe.png')
const EMOJI_MARKER_COCKTAIL_IMAGE = require('./emoji-marker-cocktail.png')
const EMOJI_MARKER_LAPTOP_IMAGE = require('./emoji-marker-laptop.png')
const EMOJI_MARKER_SAKE_IMAGE = require('./emoji-marker-sake.png')
const EMOJI_MARKER_SAVORING_IMAGE = require('./emoji-marker-savoring.png')
const EMOJI_MARKER_WHISKEY_IMAGE = require('./emoji-marker-whiskey.png')
const EMOJI_MARKER_WINE_IMAGE = require('./emoji-marker-wine.png')
const EMOJI_MARKER_INTERIOR_IMAGE = require('./emoji-marker-interior.png')

const DISABLED_EMOJI_MARKER_BAKERY_IMAGE = require('./emoji-marker-bakery-disabled.png')
const DISABLED_EMOJI_MARKER_BEER_IMAGE = require('./emoji-marker-beer-disabled.png')
const DISABLED_EMOJI_MARKER_BOOKS_IMAGE = require('./emoji-marker-books-disabled.png')
const DISABLED_EMOJI_MARKER_CAFE_IMAGE = require('./emoji-marker-cafe-disabled.png')
const DISABLED_EMOJI_MARKER_COCKTAIL_IMAGE = require('./emoji-marker-cocktail-disabled.png')
const DISABLED_EMOJI_MARKER_LAPTOP_IMAGE = require('./emoji-marker-laptop-disabled.png')
const DISABLED_EMOJI_MARKER_SAKE_IMAGE = require('./emoji-marker-sake-disabled.png')
const DISABLED_EMOJI_MARKER_SAVORING_IMAGE = require('./emoji-marker-savoring-disabled.png')
const DISABLED_EMOJI_MARKER_WHISKEY_IMAGE = require('./emoji-marker-whiskey-disabled.png')
const DISABLED_EMOJI_MARKER_WINE_IMAGE = require('./emoji-marker-wine-disabled.png')
const DISABLED_EMOJI_MARKER_INTERIOR_IMAGE = require('./emoji-marker-interior-disabled.png')

const CATEGORY_MARKER_IMAGE_MAP: { [key: number]: any } = {
  82: [EMOJI_MARKER_LAPTOP_IMAGE, DISABLED_EMOJI_MARKER_LAPTOP_IMAGE],
  16: [EMOJI_MARKER_CAFE_IMAGE, DISABLED_EMOJI_MARKER_CAFE_IMAGE],
  84: [EMOJI_MARKER_SAVORING_IMAGE, DISABLED_EMOJI_MARKER_SAVORING_IMAGE],
  83: [EMOJI_MARKER_BAKERY_IMAGE, DISABLED_EMOJI_MARKER_BAKERY_IMAGE],
  76: [EMOJI_MARKER_BOOKS_IMAGE, DISABLED_EMOJI_MARKER_BOOKS_IMAGE],
  21: [EMOJI_MARKER_SAKE_IMAGE, DISABLED_EMOJI_MARKER_SAKE_IMAGE],
  20: [EMOJI_MARKER_WHISKEY_IMAGE, DISABLED_EMOJI_MARKER_WHISKEY_IMAGE],
  19: [EMOJI_MARKER_COCKTAIL_IMAGE, DISABLED_EMOJI_MARKER_COCKTAIL_IMAGE],
  18: [EMOJI_MARKER_WINE_IMAGE, DISABLED_EMOJI_MARKER_WINE_IMAGE],
  17: [EMOJI_MARKER_BEER_IMAGE, DISABLED_EMOJI_MARKER_BEER_IMAGE],
  85: [EMOJI_MARKER_INTERIOR_IMAGE, DISABLED_EMOJI_MARKER_INTERIOR_IMAGE],
}

export const getCategoryMarkerImage = (
  categoryId: number,
  isDisabled: boolean,
) => {
  const pair = CATEGORY_MARKER_IMAGE_MAP[categoryId]
  if (!pair) return null
  return pair[isDisabled ? 1 : 0]
}
